import type { IBracketStore, } from "@store/types";
import type { StateCreator, } from "zustand";
import { createLeaderBoardSlice, } from "./leaderBoardSlice";
import { createPointsSlice, } from "./pointsSlice";
import type{ IBarsSlice, } from "./types";
import { createWalletPointsSlice, } from "./walletPointsSlice";



export const createBarsSlice: StateCreator<IBracketStore, [], [], IBarsSlice> = (...args) => {


	const fetch = async () => {
		console.warn("createBarsSlice::fetch not implemented");
	}

	const reset = () => {
		console.warn("createBarsSlice::reset not implemented");
	}

	const resetAsync = async () => {
		console.warn("createBarsSlice::resetAsync not implemented");
	}

	// place at the bottom of the call stack.
	// setTimeout(_ => fetch(), 0);

	return {
		ready: false,
		fetching: false,
		walletPoints: createWalletPointsSlice(...args),
		leaderboard: createLeaderBoardSlice(...args),
		points: createPointsSlice(...args),
		fetch,
		reset,
		resetAsync,
	};

};
